export const pdfsActions = {

    FETCH_PDF_FAILED: 'FETCH_PDF_FAILED',
    FETCH_PDF_SUCCESS: 'FETCH_PDF_SUCCESS',
    FETCH_PDF_PENDING: 'FETCH_PDF_PENDING',
    OPEN_FULL_REPORT_TT: 'OPEN_FULL_REPORT_TT',
    OPEN_FULL_REPORT_MP: 'OPEN_FULL_REPORT_MP',

    fetchPdfFailed: error => ({
        type: pdfsActions.FETCH_PDF_FAILED,
        payload: error
    }),

    fetchPdfSuccess: (id, data) => ({
        type: pdfsActions.FETCH_PDF_SUCCESS,
        payload: {
            data,
            id
        }
    }),

    fetchPdfPending: () => ({
        type: pdfsActions.FETCH_PDF_PENDING,
    }),

    loadFullReportTT: () => ({
        type: pdfsActions.OPEN_FULL_REPORT_TT,
    }),

    loadFullReportMP: () => ({
        type: pdfsActions.OPEN_FULL_REPORT_MP,
    }),

};

export const pdfsRequestActions = {
    failed: pdfsActions.fetchPdfFailed,
    success: pdfsActions.fetchPdfSuccess,
    pending: pdfsActions.fetchPdfPending
};
